import ActualizarClave   from "@/views/regLog/ActualizarClave.vue";
import CargarPDFs        from "@/components/CargarPDFs.vue";
import IndexadorPDFs     from "@/components/IndexadorPDFs.vue";
import CargarIndexarPDFs from "@/components/CargarIndexarPDFs.vue";

export default [
  {
    path: "/actualizarclave",
    name: "ActualizarClave",
    component: ActualizarClave,
    props: (route) => ({
      usuario: route.query.usuario || window.sessionStorage.getItem('usuario') || '',
      idUsuario: route.query.idUsuario || window.sessionStorage.getItem('idUsuario') || 0,
    }),
  },
  {
    path: "/cargar-pdfs/:p_idtramite",
    name: "CargarPDFs",
    component: CargarPDFs,
  },
  {
    path: "/indexador-pdfs/:p_idtramite",
    name: "IndexadorPDFs",
    component: IndexadorPDFs,
  },
  {
    path: "/cargar-indexar-pdfs/:p_idtramite",
    name: "CargarIndexarPDFs",
    component: CargarIndexarPDFs,
  },
];
